/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ex_TitleInputs */

const en_to_csv_ex_title = /** @type {(inputs: To_Csv_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting records with uneven keys`)
};

const ko_to_csv_ex_title = /** @type {(inputs: To_Csv_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키가 고르지 않은 레코드 변환하기`)
};

const ja_to_csv_ex_title = /** @type {(inputs: To_Csv_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーが揃っていないレコードを変換する`)
};

/**
* | output |
* | --- |
* | "Converting records with uneven keys" |
*
* @param {To_Csv_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ex_title = /** @type {((inputs?: To_Csv_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ex_title(inputs)
	if (locale === "ko") return ko_to_csv_ex_title(inputs)
	return ja_to_csv_ex_title(inputs)
});